import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Show from 'components/Form/Show';

const getErrorList = (section) => {
  const list = [];
  section.subsections.forEach((ss) => {
    let isValid = ss.isValid;
    if (isValid !== false && ss.subsections) {
      isValid = !ss.subsections.some((secondSS) => secondSS.isValid === false);
    }
    if (isValid === false) {
      list.push(<li key={`package-review-errors-${ss.key}`}>{ss.label}</li>);
    }
  });
  return list.length > 0 ? <ul>{list}</ul> : null;
};

/** For use with top-level form sections only */
const InvalidSection = ({ section }) => (
  <div className="field">
    <div className="table expand">
      <div className="usa-alert usa-alert-error" role="alert">
        <div className="usa-alert-body">
          <h5 className="usa-alert-heading">{section.label}</h5>
          {getErrorList(section)}
          <Show when={section.path === 'package'}>
            <Link to={`/form/${section.path}/comments`}>
              <button type="button" className="back usa-button-outline">
              Back to section
              </button>
            </Link>
          </Show>
          <Show when={section.path !== 'package'}>
            <Link to={`/form/${section.path}/review`}>
              <button type="button" className="back usa-button-outline">
              Back to section
              </button>
            </Link>
          </Show>
        </div>
      </div>
    </div>
  </div>
);

InvalidSection.propTypes = {
  section: PropTypes.object.isRequired,
};

export default InvalidSection;
